// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol___4-nx","author":"Table_author__2S5c0","authorImage":"Table_authorImage__3NRpu","unreadRow":"Table_unreadRow__3W4t6"};